var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "states-bar-container" } },
    [
      _c("progress-bar", {
        attrs: {
          interactive: "",
          progress: _vm.progress,
          steps: _vm.states,
          "selected-steps": _vm.getProfileStatusLabelId({
            id: _vm.clientProfileId,
          }),
          loading: _vm.loading,
        },
        on: { change: _vm.updateCurrentStatus },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }